"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "defineDefaultContentType", {
    enumerable: true,
    get: function() {
        return defineDefaultContentType;
    }
});
var _to_array = require("@swc/helpers/_/_to_array");
var defineDefaultContentType = function() {
    var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!pathname) {
        return "";
    }
    var _pathname_split_filter = _to_array._(pathname.split("/").filter(Boolean)), locale = _pathname_split_filter[0], indexPage = _pathname_split_filter[1], detailPage = _pathname_split_filter[2], rest = _pathname_split_filter.slice(3);
    if (rest.length) {
        return "";
    }
    if ((locale === null || locale === void 0 ? void 0 : locale.length) !== 2) {
        return "";
    }
    if (!indexPage) {
        return "";
    }
    var sanitizeName = indexPage.replace("-", "_");
    if (detailPage) {
        return "".concat(sanitizeName, "_details");
    }
    if (indexPage) {
        return "".concat(sanitizeName, "_index");
    }
    return "";
};

//# sourceMappingURL=defineDefaultContentType.js.map